import TwoFactorActivation from "./TwoFactorActivation.vue";
export default TwoFactorActivation;
